import { render, staticRenderFns } from "./update_shop_name.vue?vue&type=template&id=e952ae68&scoped=true&"
import script from "./update_shop_name.vue?vue&type=script&lang=js&"
export * from "./update_shop_name.vue?vue&type=script&lang=js&"
import style0 from "./update_shop_name.vue?vue&type=style&index=0&id=e952ae68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e952ae68",
  null
  
)

export default component.exports